import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ children, variant = 'primary', size = 'md', to, onClick, type = 'button', className = '', fullWidth }) => {
  const baseStyles = "inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 transform active:scale-95";
  
  const variants = {
    primary: "bg-secondary text-primary font-bold hover:bg-secondary-hover shadow-md",
    secondary: "bg-primary text-white hover:bg-primary-light shadow-md",
    outline: "border-2 border-primary text-primary hover:bg-slate-50",
    ghost: "text-slate-600 hover:text-primary hover:bg-slate-100",
    accent: "bg-accent text-primary hover:bg-accent-hover shadow-md font-bold"
  };

  const sizes = {
    sm: "px-4 py-2 text-sm",
    md: "px-6 py-3 text-base",
    lg: "px-8 py-4 text-lg"
  };

  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;

  if (to) {
    return <Link to={to} className={classes}>{children}</Link>;
  }

  return (
    <button type={type} onClick={onClick} className={classes}>
      {children}
    </button>
  );
};

export default Button;